import {observer} from 'mobx-react';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {MQOptions} from '../../models';
import {MQDataPairStore} from '../stores/MQDataPairStore';
import {MQDataPairLeft} from './MQDataPairLeft';

@observer
export class MQDataPairComponent extends React.Component<{
  options: MQOptions,
  store: MQDataPairStore
}> {

  render() {
    const {store, options, children} = this.props;

    return (
      <div className="row">
        <div className="col">
          <MQDataPairLeft options={options} store={store}/>
        </div>
        <div className="col">
          <TextareaAutosize className="form-control"
                            value={store.right.value}
                            onChange={store.right.onChangeHandler}/>
        </div>
        <div className="col-auto">
          <div className="form-check">
            <label className="form-check-label">
              <input type="checkbox" className="form-check-input"
                     checked={store.fixed.value}
                     onChange={store.fixed.onChangeHandler}/>
              Fixed
            </label>
          </div>
        </div>
        <div className="col-auto">
          {children}
        </div>
      </div>
    );
  }
}
